var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFraud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    fillRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.367.333L.961 8.106c-.417.211-.693.646-.688 1.087 0 9.317 2.089 15.368 5.2 19.626 3.11 4.257 7.171 6.644 10.812 8.81a1.443 1.443 0 001.43 0c3.641-2.166 7.7-4.553 10.813-8.81 3.113-4.258 5.2-10.31 5.2-19.626.004-.441-.271-.876-.688-1.087L17.633.333c-.479-.215-.846-.188-1.265 0zM17 2.813v32.322c-3.4-2.033-6.752-4.155-9.34-7.697-2.69-3.68-4.594-9.016-4.705-17.541L17 2.813z"
  })));
}
export default SvgFraud;